import { render, staticRenderFns } from "./BankCard.vue?vue&type=template&id=03906eda&scoped=true&"
import script from "./BankCard.vue?vue&type=script&lang=ts&"
export * from "./BankCard.vue?vue&type=script&lang=ts&"
import style0 from "./BankCard.vue?vue&type=style&index=0&id=03906eda&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03906eda",
  null
  
)

export default component.exports